import Request from "@/services/request";
import gql from "graphql-tag";
import {
  SELLER_DASHBOARD_QUERY,
  SALES_GRAPH_QUERY,
  DASHBOARD_INVOICE,
  NOTIFICATION_QUERY,
} from "@/utils/enum/endpoints";
import * as apollo from "../../../plugins/graphql/apollo";

const request = new Request();

export default {
  async getSellerBanner({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=DASHBOARD_RIGHT_FIRST_BANNER`
      );
      return data.DASHBOARD_RIGHT_FIRST_BANNER.dtoList;
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },

  async getSellerPerformanceMetrics({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=SELLER_PERFORMANCE_METRICS`
      );
      return data.SELLER_PERFORMANCE_METRICS;
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },

  async getSellerShop({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=SELLER_SHOP`
      );
      return data.SELLER_SHOP;
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },

  async getAnnoucements({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=NOTICES`
      );
      return data.NOTICES.dtoList;
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },

  async getCustomerModule({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=REVIEWS_SUMMARY`
      );
      return data.REVIEWS_SUMMARY;
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getInvoiceModule() {
    try {
      const { data } = await request.get(DASHBOARD_INVOICE, null, {
        baseURL: "/selleroffice/rest",
        headers: { Accept: "application/json" },
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getCreatingNewBannerModule({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=DASHBOARD_LEFT_FIRST_BANNER`
      );
      return Promise.resolve(data.DASHBOARD_LEFT_FIRST_BANNER.dtoList);
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getCampaignsBanner({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=CAMPAIGN_INVENTORY`
      );
      return data.CAMPAIGN_INVENTORY;
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getDetailsBannerImage({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=DASHBOARD_RIGHT_SECOND_BANNER`
      );
      return data.DASHBOARD_RIGHT_SECOND_BANNER.dtoList;
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getRefundModule({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=CLAIM_SUMMARY`
      );
      return data.CLAIM_SUMMARY;
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getOrderModule({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=ORDER_SUMMARY`
      );
      return data.ORDER_SUMMARY;
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getChartData({ rootState }, payload) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.post(`${SALES_GRAPH_QUERY}`, {
        ...payload,
        sellerId,
      });
      return Promise.resolve(data);
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },

  async getShopSupportInventory({ rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(
        `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=STORE_SUPPORT_INVENTORY`
      );
      return Promise.resolve(data.STORE_SUPPORT_INVENTORY);
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async getAdSummaryModule({ rootState }, payload) {
    const { sellerId } = rootState.auth.user;
    const { days } = payload;
    try {
      const { data } = await apollo.apolloClient.query({
        query: gql`
          query ($sellerId: Long!, $days: Int!) {
            existAnyAdsToEndInThreeDays: existAnyAdsToEndInThreeDays(
              sellerId: $sellerId
            )
            getAdAnalyticsQuery: getAdAnalyticsQuery(sellerId: $sellerId) {
              sellerTotalAdCount
            }
            sellerPointAccount: getSellerPointAccount(sellerId: $sellerId) {
              content {
                sellerId
                balance
                effectiveBalance
                accountType
              }
            }
            hasAnySellerPointExpireIn: hasAnySellerPointExpireIn(
              days: $days
              sellerId: $sellerId
            )
            gift: getIfSellerLastDepositTransactionSourceIsGift(
              sellerId: $sellerId
            ) {
              pointAmount
            }
          }
        `,
        variables: {
          sellerId,
          days,
        },
      });
      return Promise.resolve(data);
    } catch (data) {
      return Promise.reject(data);
    }
  },

  async notificationQuery({ commit, rootState }) {
    try {
      const { sellerId } = rootState.auth.user;
      const { data } = await request.get(`${NOTIFICATION_QUERY}/${sellerId}`);

      commit("SET_SELLER_TICKET_COUNT", data.sellerTicketCount);
      commit("SET_N11_TICKET_COUNT", data.n11TicketCount);
      return data;
    } catch ({ data }) {
      return Promise.reject(data);
    }
  },
};
